const CLEAR_REDUCERS = 'CLEAR_REDUCERS';

export { CLEAR_REDUCERS };
